// extracted by mini-css-extract-plugin
export default {"icon":"icon__aqV2v","dropdown":"dropdown__0tNAn","text":"text__fevjP","bottom":"bottom__04i9O"};